import { render } from "./BtnBottom.vue?vue&type=template&id=1da17ffa&scoped=true"
import script from "./BtnBottom.vue?vue&type=script&lang=js"
export * from "./BtnBottom.vue?vue&type=script&lang=js"

import "@/assets/css/user/common.css?vue&type=style&index=0&id=1da17ffa&scoped=true&lang=css"
import "@/assets/css/user/pages/payment.css?vue&type=style&index=1&id=1da17ffa&scoped=true&lang=css"
import "@/assets/css/user/dark/common-dark.css?vue&type=style&index=2&id=1da17ffa&scoped=true&lang=css"
import "@/assets/css/user/dark/payment-dark.css?vue&type=style&index=3&id=1da17ffa&scoped=true&lang=css"
import "./BtnBottom.vue?vue&type=style&index=4&id=1da17ffa&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shcho\\Desktop\\home\\git\\test\\cloudpos.kiosk\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1da17ffa"]])

export default __exports__